export const faqContent = {
  subtitle: "FAQ",
  title: "Support that feels like part of your team.",
  questions: [
    {
      question: "How do you ensure accuracy?",
      answer:
        "We hire **engineers**, we have a **top notch development program**, we have a **quality control process** that scrutinizes every estimate and we provide our clients with everything they need to make **fully informed decisions**.",
    },
    {
      question: "How fast can you turn around a bid?",
      answer:
        "Typical turnaround is **3-7 business days**, depending on project scope and vendors. We also offer **rush options** if needed.",
    },
    {
      question: "Will I lose control of the estimating process?",
      answer:
        "Not at all — you stay in control while we do the **heavy lifting**. We provide **clarity**, **transparency**, and **regular communication**. You have access to key software we utilize.",
    },
    {
      question: "What if I only need occasional support?",
      answer: "We will **tailor a monthly plan** to suit your needs.",
    },
  ],
};
